/**
 * Environment-safe Logger — unterdrückt Logs in Production.
 * DSGVO-konform: Keine PHI, keine User-IDs in Prod-Logs.
 */
const isDev = import.meta.env.DEV;

export const logger = {
  debug: (...args: unknown[]) => {
    if (isDev) console.debug('[MediFlow]', ...args);
  },
  info: (...args: unknown[]) => {
    if (isDev) console.log('[MediFlow]', ...args);
  },
  warn: (...args: unknown[]) => {
    console.warn('[MediFlow]', ...args);
  },
  error: (...args: unknown[]) => {
    console.error('[MediFlow]', ...args);
  },
} as const;
